import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/about", label: "About" },
  { to: "/what-is-family-constellation", label: "What Is It" },
  { to: "/how-it-works", label: "How It Works" },
  { to: "/services", label: "Services" },
  { to: "/workshops", label: "Workshops" },
  { to: "/resources", label: "Resources" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location]);

  return (
    <nav className="fixed top-0 w-full z-50 bg-parchment/95 backdrop-blur border-b hairline" data-testid="main-navbar">
      <div className="container-page flex justify-between items-center h-20">
        <Link to="/" className="text-3xl text-earth font-display" data-testid="logo-link" style={{ fontWeight: 600 }}>
          अन्वय
        </Link>
        <div className="hidden md:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `text-sm font-semibold uppercase tracking-wider transition-colors ${
                  isActive ? "text-gold-dark" : "text-earth/70 hover:text-earth"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <Link to="/book" className="hidden md:inline-flex btn-gold text-sm px-5 py-2.5" data-testid="nav-book-btn">
            Book a Session
          </Link>
          <button
            className="md:hidden text-earth p-2"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-parchment border-t hairline animate-fade-in" data-testid="mobile-menu">
          <div className="container-page py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className="py-3 text-base font-semibold text-earth border-b hairline last:border-0"
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
